
import { defineComponent } from "vue";
import { Optional } from "@/globalTypes";
import { mapActions } from "vuex";
import LoginButtons from "@/accounts/LoginButtons.vue";
import { sendGTMEvent } from "@/utils";

interface RegistrationData {
  email: String;
  emailError: Optional<String>;
  isRegistered: Boolean;
  isRegistrationPending: Boolean;
}

export default defineComponent({
  components: { LoginButtons },
  data(): RegistrationData {
    return {
      email: "",
      emailError: null,
      isRegistered: false,
      isRegistrationPending: false,
    };
  },
  methods: {
    ...mapActions("accounts", ["register"]),
    ...mapActions("cars", ["createTmpCar"]),
    handleRegistration() {
      if (!this.email) {
        this.emailError = "Musisz podać adres email!";
        return;
      }
      this.isRegistrationPending = true;
      this.register(this.email).then(({ success, result, errors }) => {
        if (success) {
          sendGTMEvent({ event: "rejestracja-niepotwierdzona" }, () => {
            this.isRegistrationPending = false;
            this.isRegistered = true;
            this.createTmpCar(result.id);
          });
        } else {
          this.emailError = errors;
          this.isRegistrationPending = false;
        }
      });
    },
  },
});
